export default {
  addTranslation: { id: 'add_translation' },
  title: { id: 'title' },
  en: { id: 'english_translation' },
  es: { id: 'spanish_translation' },
  th: { id: 'thai_translation' },
  pt: { id: 'portuguese_translation' },
  ru: { id: 'russian_translation' },
  uk: { id: 'ukrainian_translation' },
  no: { id: 'norwegian_translation' },
  pl: { id: 'polish_translation' },
}
